export default {
    NotGrandVideoPermission: 'NotGrandVideoPermission',
    NoCamera: 'NoCamera',
}
